import React from "react";
import ParticipateForm from "../components/ParticipateForm";
import { SITE } from "../lib/api";
import { MessageCircle, Instagram, Mail, MapPin } from "lucide-react";

export default function Contato() {
  return (
    <div data-testid="page-contato" className="pt-24 md:pt-32 bg-[#FAF9F6]">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pb-16">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
          <span className="accent-line" />
          Contato
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
          Vamos <em className="italic font-light">conversar</em>.
        </h1>
      </header>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-200">
        {[
          { i: <MessageCircle size={22} />, t: "WhatsApp", v: SITE.whatsappDisplay, href: `https://wa.me/${SITE.whatsapp}` },
          { i: <Mail size={22} />, t: "E-mail", v: SITE.email, href: `mailto:${SITE.email}` },
          { i: <Instagram size={22} />, t: "Instagram", v: SITE.instagramHandle, href: SITE.instagram },
          { i: <MapPin size={22} />, t: "Cidade", v: "Lauro de Freitas — BA", href: "#" },
        ].map((c) => (
          <a
            key={c.t}
            href={c.href}
            target="_blank"
            rel="noreferrer"
            data-testid={`contact-card-${c.t.toLowerCase()}`}
            className="bg-white p-8 hover:bg-[#003F88] hover:text-white transition-colors"
          >
            <div className="text-[#003F88] group-hover:text-[#FFC72C]">{c.i}</div>
            <div className="mt-6 text-[10px] uppercase tracking-[0.22em] opacity-70">{c.t}</div>
            <div className="font-serif-display text-xl md:text-2xl mt-2">{c.v}</div>
          </a>
        ))}
      </section>

      <ParticipateForm />
    </div>
  );
}
